<template>
  <div class="quiz-modal-component">
    <h6 class="text-center mb-4">
      <i class="icon-exam"></i> {{ score.quiz.title }}
    </h6>
    <div class="text-center text-danger mb-4">{{ countdown }}</div>

    <quiz-paginator-line
      v-if="Object.keys(answers).length"
      :questions="questions"
      :answers="answers"
      :index="question_index"
      @go-to="goTo"
    />

    <h5 class="page-title xsm  mb-4">
      {{ questions[question_index].title }}
    </h5>

    <template v-if="Object.keys(answers).length">
      <div
        v-for="a in questions[question_index].answer_options"
        :key="a.id"
        class="mb-3 mb-lg-4"
      >
        <form-radio
          v-model="answers[questions[question_index].id].answer_option"
          :input-value="a.id"
          :label="a.title"
          :id="a.id"
        />
      </div>
    </template>

    <div class="d-flex justify-content-end pt-5">
      <button
        v-if="question_index > 0"
        class="btn btn-outline-secondary px-4 mr-4"
        @click="previous"
      >
        <i class="icon-chevron-left mr-2"></i> Voltar
      </button>
      <button
        v-if="question_index < questions.length - 1"
        class="btn px-4"
        :class="{
          'btn-light': $setup.theme == 'dark',
          'btn-primary': $setup.theme == 'light'
        }"
        @click="next"
      >
        Próximo <i class="icon-chevron-right ml-2"></i>
      </button>
      <button
        v-if="question_index == questions.length - 1"
        class="btn px-4"
        :class="{
          'btn-light': $setup.theme == 'dark',
          'btn-primary': $setup.theme == 'light'
        }"
        @click="save"
      >
        <loading :show="submitLoading" small>Enviar</loading>
      </button>
    </div>
  </div>
</template>
<script>
import QuizPaginatorLine from "@/components/lesson/quiz/fragment/QuizPaginatorLine";
import {
  duration_seconds_to_humanized,
  diff_from_now
} from "@/functions/helpers";

export default {
  components: { QuizPaginatorLine },
  props: {
    score: {
      type: Object,
      default: () => {}
    },
    submitLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      question_index: 0,
      countdown: "",
      timeout: null,
      answers: {},
      STORAGE_KEYS: {
        TIMEOUT: `${window.location.host}_QUIZ_TIMEOUT_${this.$user.user.email}`,
        ANSWERS: `${window.location.host}_QUIZ_ANSWERS_${this.$user.user.email}`
      }
    };
  },
  watch: {
    answers: {
      deep: true,
      handler: function(value) {
        if (Object.keys(value).length) {
          localStorage.setItem(
            this.STORAGE_KEYS.ANSWERS,
            JSON.stringify(value)
          );
          this.$emit("on-answer", value);
        }
      }
    }
  },
  mounted() {
    this.prepareCountdown();
    this.prepareAnswers();
  },
  beforeUnmount() {
    clearTimeout(this.timeout);
  },
  computed: {
    questions() {
      return [...this.score.quiz.questions].sort((a, b) => a.sort - b.sort);
    }
  },
  methods: {
    goTo(index) {
      this.question_index = index;
    },
    prepareAnswers() {
      const local_answers = localStorage.getItem(this.STORAGE_KEYS.ANSWERS);

      if (local_answers) {
        this.answers = JSON.parse(local_answers);
      } else {
        this.answers = this.questions.reduce(
          (acc, curr) => ({
            ...acc,
            [curr.id]: { question: curr.id, answer_option: "" }
          }),
          {}
        );
      }
    },
    prepareCountdown() {
      if (this.score.quiz.time_limit_minutes > 0) {
        const initial_time = diff_from_now(this.score.started_at);
        this.countdown = duration_seconds_to_humanized(initial_time);
        localStorage.setItem(this.STORAGE_KEYS.TIMEOUT, initial_time);

        this.timeout = setInterval(() => {
          if (this.score && this.score.quiz_answers.length) {
            localStorage.removeItem(this.STORAGE_KEYS.TIMEOUT);
            clearInterval(this.timeout);
          }

          const diff_in_seconds = diff_from_now(this.score.started_at);
          const diff_in_minutes = diff_in_seconds / 60;
          if (diff_in_minutes < this.score.quiz.time_limit_minutes) {
            this.countdown = duration_seconds_to_humanized(diff_in_seconds);
            localStorage.setItem(this.STORAGE_KEYS.TIMEOUT, diff_in_seconds);
          } else {
            this.$message.warning("Tempo esgotado para realização da prova!");
            this.$emit("timeover");
            localStorage.setItem(this.STORAGE_KEYS.TIMEOUT, 0);
            clearInterval(this.timeout);
          }
        }, 1000);
      }
    },
    change(val) {
      this.$emit("input", val);
    },
    next() {
      const lastIndex = this.questions.length - 1;
      if (this.question_index + 1 <= lastIndex) {
        this.question_index += 1;
      }
    },
    previous() {
      if (this.question_index - 1 >= 0) {
        this.question_index -= 1;
      }
    },
    save() {
      let missing_index = null;
      for (let k in this.answers) {
        if (this.answers[k].answer_option.length == 0) {
          missing_index = this.questions.findIndex(
            ({ id }) => id == this.answers[k].question
          );
          break;
        }
      }

      if (missing_index !== null) {
        this.$message.warning(
          `Por favor, responda a questão ${missing_index + 1}`
        );
        return;
      }

      this.$emit(
        "save",
        Object.entries(this.answers).map(([_, v]) => v)
      );

      this.$emit("clear-local-storage");
    }
  }
};
</script>
<style lang="scss" scoped>
.quiz-modal-component {
  .icon-close {
    position: absolute;
    top: 2%;
    right: 0%;
  }
}
</style>
